import React from "react";
import {
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
} from "@coreui/react";
import staticData from "../../assests/staticData.json";

export default function Faq() {
  const { faqs_list } = staticData;
  return (
    <CAccordion>
      {faqs_list.length > 0 &&
        faqs_list.map((faq) => (
          <CAccordionItem key={faq.id}  itemKey={faq.id}>
            <CAccordionHeader>
              {faq.question}
            </CAccordionHeader>
            <CAccordionBody>
            {faq.answer}
            </CAccordionBody>
          </CAccordionItem>
        ))}
    </CAccordion>
  );
}
